window.jQuery = window.$ = require('jqueryModule');
